import { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AtSign, Bell, CircleUserRound, Users } from "lucide-react";
import { useQuery } from "../AppLayout";
import SettingTabs from "../team/component/SettingTabs";
import ProfileSetting from "./ProfileSetting";
import EmailSetting from "./EmailSetting";
import NotificationSetting from "./NotificationSetting";
import TeamAndSessionsSetting from "./TeamAndSessionsSetting";

const UserSetting = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { projectId }: any = useParams();
  const currentParams = useQuery();
  const tenantInfo = useSelector((state: any) => state.tenant?.get?.("tenantInfo"));
  const canSwitchTeam =
    tenantInfo?.get?.("canSwitchTeam") === true || (tenantInfo as any)?.canSwitchTeam === true;

  const settingType = currentParams.get("item") || "profile";

  useEffect(() => {
    document.title = t("User Setting");
  }, [t]);

  const onSettingTypeChange = (type) => {
    navigate(`/workspaces/${projectId}/settings/user?item=${type}&key=User%20Settings`);
  };

  const tabs = useMemo(() => {
    const base = [
      {
        id: "profile",
        label: t("Profile"),
        icon: <CircleUserRound className="w-4 h-4" />,
      },
      {
        id: "notifications",
        label: t("Notifications"),
        icon: <Bell className="w-4 h-4" />,
      },
      {
        id: "mail",
        label: t("Email & Calendar"),
        icon: <AtSign className="w-4 h-4" />,
      },
    ];
    if (canSwitchTeam) {
      base.push({
        id: "teams-sessions",
        label: t("Teams & Sessions"),
        icon: <Users className="w-4 h-4" />,
      });
    }
    return base;
  }, [t, canSwitchTeam]);

  return (
    <div className={"p-4"}>
      <SettingTabs tabs={tabs} activeTabId={settingType} onTabChange={onSettingTypeChange} />
      {settingType === "profile" ? <ProfileSetting /> : null}
      {settingType === "notifications" ? <NotificationSetting /> : null}
      {settingType === "mail" ? <EmailSetting /> : null}
      {settingType === "teams-sessions" && canSwitchTeam ? <TeamAndSessionsSetting /> : null}
    </div>
  );
};

export default UserSetting;
